import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'Comic Sans MS, cursive'
    },
});

export default theme;
